import background from 'assets/img/research/logistics-bg.jpg'
import { Fragment } from 'react'

export const logistics = {
  background: background,
  title: 'Logistics',
  toggleData: [
    {
      sectionTitle: 'Data Science',
      logisticsList: [
        {
          subTitle: 'Grades',
          desc: 'Incoming 9th-12th graders + college freshmen',
        },
        {
          subTitle: 'Dates & Time',
          desc: (
            <Fragment>
              June 29 - July 24, 2026
              <span className="d-block">Monday - Friday</span>
              <span className="d-block mb-5">12 - 4pm ET (9am - 1pm PT)</span>
              <small className="d-block mb-5">
                *Must be able to join live sessions
              </small>
              <small className="d-block text-italic">
                *Presentations: 1 day between Aug 5-14
              </small>
            </Fragment>
          ),
        },
        {
          subTitle: 'Location',
          desc: (
            <Fragment>
              <span className="d-block mb-5">
                Virtual, with live instruction
              </span>
              <small className="d-block">
                *Special events such as campus or facility tours, community
                events, and speaker panels may periodically take place virtually
                or in-person depending on a student’s regional hub.
              </small>
            </Fragment>
          ),
        },
        {
          subTitle: 'Prerequisites',
          desc: (
            <Fragment>
              <span className="d-block mb-5">
                No prior STEM experience required; students will learn all
                skills required during the program.
              </span>
            </Fragment>
          ),
        },
        {
          subTitle: 'Tuition',
          desc: (
            <Fragment>
              <span className="d-block mb-5">
                <span className="text-gold">FREE </span> for up to 100 accepted
                students located in:
              </span>
              <ul className="list-tuition mb-15">
                <li>Maryland</li>
                <li>D.C.</li>
                <li>New York City</li>
                <li>Southern California</li>
                <li>Virginia (DMV area)</li>
                <li>Rural communities</li>
              </ul>
              {/* <span className="d-block mb-5">
              <strong className="text-gold">100 Full Scholarships available</strong> <br /> (see below)</span> */}
              <span className="d-block mb-5 text-italic">
                *select students from above regions will also receive a $750
                stipend.
              </span>
              <span className="d-block mb-5">
                Students in other regions: $3,995
              </span>
              <span className="d-block mb-5 text-italic">
                <small>*limited Need-based scholarships available</small>
              </span>
              <small className="d-block mb-5 text-italic">
                *Military-connected students are encouraged to apply for all
                scholarship opportunities*
              </small>
            </Fragment>
          ),
        },
        {
          subTitle: 'Application Deadline',
          desc: (
            <Fragment>
              Priority Deadline: February 1, 2026
              <span className="d-block mt-5">
                2nd Priority Deadline: March 15, 2026
              </span>
            </Fragment>
          ),
        },
      ],
      extraInfo: [
        // {
        //   title: (
        //     <Fragment>
        //       Become a <span className="text-gold">DSRP Scholar</span> this
        //       Summer
        //     </Fragment>
        //   ),
        //   desc: [
        //     <span className="text-gold text-bold fs-16">
        //       100 Full Scholarships will be awarded!
        //     </span>,
        //     <Fragment>
        //       <span className="mb-10 d-block">
        //         Plus a $750 stipend given to students for program completion
        //       </span>
        //     </Fragment>,
        //     <Fragment>
        //       Eligibility: Resident of{' '}
        //       <strong>
        //         {' '}
        //         New York, Washington D.C., Maryland, Virginia, Southern
        //         California
        //       </strong>
        //       , and <strong>rural areas across the U.S.</strong>
        //     </Fragment>,
        //     <Fragment>
        //       <small>
        //         *Military-connected students are encouraged to apply.
        //         <br />
        //         *The DSRP Scholars Program is made possible thanks to the U.S.
        //         Department of War (DoW) and the Defense STEM Education
        //         Consortium (DSEC).
        //       </small>
        //     </Fragment>,
        //   ],
        // },
        {
          desc: [
            'Scholarships & stipends  made possible thanks to the U.S. Department of War (DoW) and the Defense STEM Education Consortium (DSEC).',
          ],
        },
      ],
    },
    {
      sectionTitle: 'Quantum Computing',
      logisticsList: [
        {
          subTitle: 'Grades',
          desc: 'Incoming 10th-12th graders + college freshmen',
        },
        {
          subTitle: 'Dates & Time',
          desc: (
            <Fragment>
              June 29 - Jul 31, 2026
              <span className="d-block">Monday - Friday</span>
              <span className="d-block mb-5">
                Weeks 1-2: 12-5pm ET (9am-2pm PT)
              </span>
              <span className="d-block mb-5">
                Weeks 3-5: 12-4pm ET (9-1pm PT)
              </span>
              <small className="d-block mb-5">
                *Must be able to join live sessions
              </small>
              <small className="d-block text-italic">
                *Presentations: 1 day between Aug 5-14
              </small>
            </Fragment>
          ),
        },
        {
          subTitle: 'Location',
          desc: (
            <Fragment>
              <span className="d-block mb-5">
                Virtual, with live instruction
              </span>
              <small className="d-block">
                *Special events such as campus or facility tours, community
                events, and speaker panels may periodically take place virtually
                or in-person depending on a student’s regional hub.
              </small>
            </Fragment>
          ),
        },
        {
          subTitle: 'Prerequisites',
          desc: (
            <Fragment>
              <span className="d-block mb-5">
                No prior quantum experience required; students will learn all
                skills required during the program.
              </span>
              <small className="d-block text-italic">
                *2-3 Pre-program training sessions will be required for students
                without coding experience or who have not taken TCS’ Intro to
                Quantum Computing Course
              </small>
            </Fragment>
          ),
        },
        {
          subTitle: 'Tuition',
          desc: (
            <Fragment>
              <span className="d-block mb-5">
                <span className="text-gold">FREE </span> for accepted students
                located in Maryland
              </span>
              {/* <span className="d-block mb-5 text-italic">
                *select students from Maryland will also receive a $750 stipend
              </span> */}
              <span className="d-block mb-5">
                Students in other states: $3,995
              </span>
              <small className="d-block text-italic">
                *Limited need-based scholarships available
              </small>
            </Fragment>
          ),
        },
        {
          subTitle: 'Application Deadline',
          desc: (
            <Fragment>
              Priority Deadline: February 1, 2026
              <span className="d-block mt-5">
                2nd Priority Deadline: March 15, 2026
              </span>
            </Fragment>
          ),
        },
      ],
      extraInfo: [
        // {
        //   title: (
        //     <Fragment>
        //       Become a <span className="text-gold">Equitech Scholar</span> this
        //       Summer
        //     </Fragment>
        //   ),
        //   desc: [
        //     <span className="text-gold text-bold fs-16">
        //       Full Scholarships for Maryland students!
        //     </span>,
        //     <Fragment>
        //       <span className="my-10 d-block">
        //         Thanks to Tedco’s Equitech Growth Fund Award, Maryland students
        //         can become Equitech Scholars this summer and receive full
        //         scholarships for all components of the Quantum National High
        //         School Research Program. Awarded students may also have
        //         opportunities for in-person research experiences, lab tours and
        //         meetings with leading experts in the field. No prior experience
        //         in STEM required.
        //       </span>
        //     </Fragment>,
        //     <Fragment>
        //       <small>
        //         Need-based scholarships are available for students in other
        //         states.
        //       </small>
        //     </Fragment>,
        //   ],
        // },
        {
          desc: [
            '*Maryland scholarships  made possible thanks to TEDCO Equitech Growth Fund.',
          ],
        },
      ],
    },
    {
      sectionTitle: 'Artificial Intelligence',
      logisticsList: [
        {
          subTitle: 'Grades',
          desc: 'Incoming 10th-12th graders + college freshmen',
        },
        {
          subTitle: 'Dates & Time',
          desc: (
            <Fragment>
              June 29 - Jul 31, 2026
              <span className="d-block">Monday - Friday</span>
              <span className="d-block mb-5">12-4pm ET (9am-1pm PT)</span>
              <small className="d-block mb-5">
                *Must be able to join live sessions
              </small>
              <small className="d-block text-italic">
                *Presentations: 1 day between Aug 5-14
              </small>
            </Fragment>
          ),
        },
        {
          subTitle: 'Location',
          desc: (
            <Fragment>
              <span className="d-block mb-5">
                Virtual, with live instruction
              </span>
              <small className="d-block">
                *Special events such as campus or facility tours, community
                events, and speaker panels may periodically take place virtually
                or in-person depending on a student’s regional hub.
              </small>
            </Fragment>
          ),
        },

        {
          subTitle: 'Prerequisites',
          desc: (
            <Fragment>
              <span className="d-block mb-5">Basic coding skills</span>
              <small className="d-block mb-5">
                (ie. variables, conditionals, functions, etc)
              </small>
              <small className="d-block text-italic">
                *2-3 Pre-program training sessions will be required for students
                who have not taken TCS’ Intro to Artificial Intelligence Course
              </small>
            </Fragment>
          ),
        },
        {
          subTitle: 'Tuition',
          desc: (
            <Fragment>
              <span className="d-block mb-5">$3,995</span>
              <small className="d-block text-italic">
                *Limited need-based scholarships available
              </small>
            </Fragment>
          ),
        },
        {
          subTitle: 'Application Deadline',
          desc: (
            <Fragment>
              Priority Deadline: February 1, 2026
              <span className="d-block mt-5">
                2nd Priority Deadline: March 15, 2026
              </span>
            </Fragment>
          ),
        },
      ],
      // extraInfo: [
      //   {
      //     desc: [
      //       '*Maryland scholarships  made possible thanks to TEDCO Equitech Growth Fund. ',
      //     ],
      //   },
      // ],
    },
  ],
}
